const throttle = (func, limit) => {
  let inThrottle
  return function() {
    const args = arguments
    const context = this
    if (!inThrottle) {
      func.apply(context, args)
      inThrottle = true
      setTimeout(() => inThrottle = false, limit)
    }
  }
}

const throttleWithLastCall = (func, limit) => {
  let lastFunc
  let lastRan
  return function() {
    const context = this
    const args = arguments
    if (!lastRan) {
      func.apply(context, args)
      lastRan = Date.now()
    } else {
      clearTimeout(lastFunc)
      lastFunc = setTimeout(function() {
        if ((Date.now() - lastRan) >= limit) {
          func.apply(context, args)
          lastRan = Date.now()
        }
      }, limit - (Date.now() - lastRan))
    }
  }
}

const getParameterCaseInsensitive = function(object, key) {
  return object[Object.keys(object)
      .find(k => k.toString().toLowerCase() === key.toString().toLowerCase())
  ]
}

const getDeviceType = () => {
 if (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase())) {
    window.isMobile = true;
 } else  {
    window.isMobile = false;
 }
  let device;
  if (window.isMobile) {
    device = "mobile";
  } else {
    device = "desktop";
  }
  return device;
}

export {
  throttle,
  throttleWithLastCall,
  getParameterCaseInsensitive,
  getDeviceType,
}